<template>
  <div class="ca-center">
    <ca-sidebar />
    <div class="ca-center__main">
      <router-view />
    </div>
  </div>
</template>

<script>
import CaSidebar from '../components/CaSidebar.vue'

/**
 * 个人中心布局 = 左侧导航 + 内容区。
 *
 * 承载关系（细化设计 §2.2「布局分发」）：
 *  - `layout/CaLayout.vue`  不含左侧导航 —— 仅申请页（左栏是产品图，不是导航）
 *  - 本布局                 含左侧导航   —— 我的订单 / 订单详情 / 订单编辑 / 在线续签 /
 *                                           支付订单 / 联系我们（R7 / R11）
 *
 * ⚠️ 支付订单页归含侧边栏的布局（R11 已确认），且它两个入口（申请页确认弹框 / 订单卡）
 *   渲染一致、不做区分 —— 申请页「去结算」本身要求已登录，不存在「从申请流程进来时无侧边栏」的情形。
 */
export default {
  name: 'CaCenterLayout',
  components: { CaSidebar },
}
</script>
